<template>
	<div>
		<div class="salutation-select-wrapper">
			<div v-for="salutation in currentSalutation.slice(0, 3)">
				<label v-if="customerType !== 'company'" @change="emitInputEvent($event.target.value)">
					<input
						:name="'gender' + $vnode.key"
						type="radio"
						:value="salutation.key"
						v-model="selectedSalutation"
					/>
					{{ salutation.name }}
				</label>
				<br />
			</div>
		</div>
		<slot v-if="customerType === 'private'"></slot>
	</div>
</template>

<script>
import { isNullOrUndefined } from "../../../ceres/helper/utils";

export default {
	name: "salutation-select",

	props: {
		addressData: {
			type: Object,
			required: true
		},
		addressType: {
			type: [Number, String],
			default: 1
		},
		enabledAddressFields: {
			type: Object,
			default: () => []
		},
		defaultSalutation: {
			type: String,
			default: App.config.addresses.defaultSalutation
		}
	},

	data() {
		return {
			salutations: [
				{
					key: "male",
					name: "addressSalutationMale"
				},
				{
					key: "female",
					name: "addressSalutationFemale"
				},
				{
					key: "diverse",
					name: "addressSalutationDiverse"
				},
				{
					key: "company",
					name: "addressSalutationCompany"
				}
			],
			customerType: "private",
			selectedSalutation: "",
			previousSalutation: ""
		};
	},

	computed: {
		currentSalutation() {
			const countryId = parseInt(this.addressData.countryId) || 1;
			const addressKey = parseInt(this.addressType) === 1 ? "billing_address" : "delivery_address";
			const languageKey =
				App.language === "de" ||
				App.language === "it" ||
				App.language === "fr" ||
				App.language === "pl" ||
				App.language === "es"
					? App.language
					: "en";
			const countryKey = countryId === 12 ? "gb" : "de";
			const ceresTranslations = ["de", "en", "fr", "nl", "pl"];

			const salutations = this.salutations.map((salutation) => {
				return {
					key: salutation.key,
					name: this.$translate(
						(ceresTranslations.includes(languageKey) ? "Ceres" : "Eros") + "::Template." + salutation.name
					)
				};
			});

			if (this.enabledAddressFields[countryKey].includes(`${addressKey}.name1`) || 
			this.enabledAddressFields[countryKey].includes(`${addressKey}.salutation`)) {
				return salutations;
			}

			return salutations.filter((salutation) => salutation.key !== "company" && salutation.key !== "please select");
		}
	},

	/**
	 * Get the shipping countries
	 */
	created() {
		const selectedSalutation = this.addressData.gender;

		if (isNullOrUndefined(selectedSalutation)) {
			selectedSalutation = this.defaultSalutation;
		} else {
			this.initializeInputFields(selectedSalutation);
		}

		this.emitInputEvent(selectedSalutation);
	},

	methods: {
		emitInputEvent(value) {
			const isNewGenderPersonal = this.getIsGenderPersonal(value)
            const isOldGenderPersonal = this.getIsGenderPersonal(this.addressData.gender)
            
            this.$emit("input", { field: "gender", value: value });
            // just reset the input fields, when switching the gender between a personal one and company
            if (isNewGenderPersonal !== isOldGenderPersonal)
            {
                this.$emit("input", { field: "name1", value: "" });
                this.$emit("input", { field: "name2", value: "" });
                this.$emit("input", { field: "name3", value: "" });
                this.$emit("input", { field: "vatNumber", value: "" });
                this.$emit("input", { field: "contactPerson", value: "" });
            }
		},

		checkGenderCompany(gender) {
			if (gender === "company") {
				return this.addressData.name1 !== null || this.addressData.name1 !== "";
			}
			return true;
		},

		changeSalutationType(event) {
			const value = event.target.value;
			this.emitInputEvent(
				value === "company" ? this.currentSalutation[3].key : this.previousSalutation || this.defaultSalutation
			);
		},

		initializeInputFields(salutationKey) {
			this.selectedSalutation = salutationKey;

			if (salutationKey === "company") {
				this.customerType = "company";
			}
		},

        getIsGenderPersonal(gender)
        {
            return ["male", "female", "diverse", "please select"].includes(gender);
        }
	},

	watch: {
		currentSalutation(newVal, oldVal) {
			if (newVal !== oldVal) {
				const selectedSalutation = this.addressData.gender;

				// cleanse the current selected salutation, if it's not longer included in the choice
				if (!newVal.map((salutation) => salutation.key).includes(selectedSalutation)) {
					this.emitInputEvent(newVal[0].key);
				}
			}
		},
		customerType(newVal, oldVal) {
			if (newVal !== oldVal) {
				if (newVal === "private") {
					this.selectedSalutation = this.previousSalutation;
				} else if (newVal === "company") {
					if (this.selectedSalutation !== this.currentSalutation[3].key) {
						this.previousSalutation = this.selectedSalutation;
					}
					this.selectedSalutation = this.currentSalutation[3].key;
				}
			}
		},
		addressData(newVal, oldVal) {
			if (newVal !== oldVal && !isNullOrUndefined(this.addressData.gender)) {
				this.initializeInputFields(this.addressData.gender);
			}
		}
	}
};
</script>